// สร้างตารางงวดผ่อนชำระ — ดอกเบี้ยแบบคงที่ (flat) % ต่อเดือน ตามข้อมูลเดิมของระบบ
//   ยอดรวม = เงินต้น x (1 + อัตรา/100 x จำนวนงวด) · งวดสุดท้ายรับเศษสตางค์ให้ยอดรวมตรง
const round2 = (n) => Math.round(n * 100) / 100;

/** บวกเดือนจากวันที่ YYYY-MM-DD (ถ้าเดือนปลายทางไม่มีวันนั้นให้ใช้วันสุดท้ายของเดือน) -> ISO เวลา 12:00 ท้องถิ่น */
export const addMonthsIso = (dateStr, months) => {
  const [y, m, d] = String(dateStr).slice(0, 10).split("-").map(Number);
  const lastDay = new Date(y, m - 1 + months + 1, 0).getDate();
  return new Date(y, m - 1 + months, Math.min(d, lastDay), 12, 0, 0).toISOString();
};

export const buildInstallmentSchedule = ({ principal, periods, interestRate = 0, startAt, now = new Date() }) => {
  const p = Number(principal);
  const n = Number(periods);
  const rate = Number(interestRate) || 0;
  if (!(p > 0)) throw new Error("เงินต้นต้องมากกว่า 0");
  if (!Number.isInteger(n) || n < 1 || n > 120) throw new Error("จำนวนงวดต้องเป็นจำนวนเต็ม 1-120");
  if (!(rate >= 0)) throw new Error("ดอกเบี้ยต้องไม่ติดลบ");
  if (!/^\d{4}-\d{2}-\d{2}/.test(String(startAt || ""))) throw new Error("กรอกวันเริ่มผ่อน");

  const total = round2(p * (1 + (rate / 100) * n));
  const perPeriod = round2(total / n);
  const schedule = Array.from({ length: n }).map((_, i) => {
    const dueAt = addMonthsIso(startAt, i + 1);
    return {
      period: i + 1,
      dueAt,
      amount: i === n - 1 ? round2(total - perPeriod * (n - 1)) : perPeriod,
      status: new Date(dueAt) < now ? "overdue" : "unpaid",
      paidAt: null,
    };
  });
  return { schedule, total, perPeriod, outstanding: total };
};
